import { Node } from 'reactflow'

import { useNodeAndEdgeStore } from '@ui/stores'

export const updateNodeDescription = (node: Node, description: string) => {
  const { setNodes, setRefreshLayout } = useNodeAndEdgeStore.getState()

  if (node.data.description === description) return

  setNodes((nodes) => nodes.map((n) => (n.id === node.id ? { ...n, data: { ...n.data, description } } : n)))
  setRefreshLayout(true)

  return {
    ...node,
    data: { ...node.data, description },
  }
}
